























import { Vue, Component, Watch } from 'vue-property-decorator'

const tabNames = ['summary', 'transfers', 'events', 'deposit']

@Component({ name: 'Account' })
export default class Account extends Vue {
    private tab = 0
    private address = ''
    private tabNames = ['summary', 'transfers', 'events', 'deposit']

    @Watch('tab')
    private tabChanged(newTab: number) {
        this.$router.replace({ name: this.tabNames[newTab] })
    }

    private created() {
        this.$ga.page('/insight/account')
        this.address = this.$route.params.address.toLowerCase()
        this.tab = this.tabNames.indexOf(this.$route.name!)
        if (this.tab < 0) {
            this.tab = 0
        }
    }
}
